
export const benefitsTranslations = {
  benefitsTitle: {
    fr: "Ce que First Tuesday vous apporte",
    en: "What First Tuesday brings you"
  },
  benefitMeetingsTitle: {
    fr: "Rencontres physiques régulières",
    en: "Regular physical meetings"
  },
  benefitMeetingsDesc: {
    fr: "Petits déjeuners, dîners privés et salons tech exclusifs pour créer des connexions réelles et durables.",
    en: "Breakfasts, private dinners and exclusive tech events to create real and lasting connections."
  },
  benefitOpportunitiesTitle: {
    fr: "Canal privé d'opportunités",
    en: "Private opportunity channel"
  },
  benefitOpportunitiesDesc: {
    fr: "Accès à un flux continu d'opportunités qualifiées: clients, intros, jobs et partenariats.",
    en: "Access to a continuous flow of qualified opportunities: clients, intros, jobs and partnerships."
  },
  benefitTechWatchTitle: {
    fr: "Veille tech & stratégique",
    en: "Tech & strategic watch"
  },
  benefitTechWatchDesc: {
    fr: "Informations privilégiées et analyses partagées entre membres pour rester à la pointe.",
    en: "Privileged information and analyses shared between members to stay at the cutting edge."
  },
  benefitIntrosTitle: {
    fr: "Intros de qualité",
    en: "Quality introductions"
  },
  benefitIntrosDesc: {
    fr: "Mise en relation avec talents, cofondateurs, fonds et partenaires stratégiques pré-qualifiés.",
    en: "Connections with talents, co-founders, funds and pre-qualified strategic partners."
  },
  benefitWorkshopsTitle: {
    fr: "Workshops exclusifs",
    en: "Exclusive workshops"
  },
  benefitWorkshopsDesc: {
    fr: "Formations et contenus réservés aux membres pour développer vos compétences et votre réseau.",
    en: "Training and content reserved for members to develop your skills and network."
  },
  benefitNetworkTitle: {
    fr: "Réseau international",
    en: "International network"
  },
  benefitNetworkDesc: {
    fr: "Connexion avec des leaders à travers le monde pour une perspective globale et des opportunités sans frontières.",
    en: "Connection with leaders around the world for a global perspective and opportunities without borders."
  },
};
